import React, { useContext, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../photos/logo.png";
import { AuthContext } from "../context/authContext";
import axios from "axios";

function Navbar() {
    const { logout } = useContext(AuthContext); // Updated to use lowercase "o"
    const [logoImage, setLogoImage] = React.useState(logo); // Default logo

    const location = useLocation();
    // console.log(location);
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };

    function handleLogout() { // Renamed to handleLogout
        logout();
        navigate("/login");
    }

    const org_id = localStorage.getItem("organization");

    useEffect(() => {
        const fetchWhitelabelImage = async () => {
            try {
                const response = await axios.get(`/orgs/${org_id}/whitelabel`, { withCredentials: true, });
                if (response.status === 200 && response.data) {
                    console.log('Whitelabel image data:', response.data);
                    setLogoImage(response.data.image_data);
                }
            } catch (error) {
                console.error('Error loading whitelabel image:', error);
                // Fallback to default logo if fetch fails
            }
        };

        if (org_id) {
            fetchWhitelabelImage();
        }
    }, [org_id]);

    return (
        <div className="navbar">
            {location.pathname === "/" || location.pathname === "/login" ? null : (
                <input type="button" value="Back" onClick={goBack} className="backBtn button" />
            )}
            <NavLink to="/">
                <img src={logoImage} alt="innexoLogo" className="logo" />
            </NavLink>
            {location.pathname === "/login" ? null : (
                <NavLink to="/login">
                    <input type="button" value="Logout" className="logoutBtn button" onClick={handleLogout} />
                </NavLink>
            )}
        </div>
    );
}

export default Navbar;